export const LLM_FAMILIES = {
  CUSTOM: 'custom',
};
